<template>
    <CContainer fluid class="px-0">
        <CRow>
            <CCol>
                <!-- Mapping fields -->
                <CCTableMappingFields
                    :value.sync="valueComponent.mappingFields"
                />

                <!-- Fixed fields -->
                <TableFixedFields :value.sync="valueComponent.fixedFields" />
                <CCMethodApiConfiguration
                    id="client-pre-validation-configuration"
                    :value.sync="methodApiConfiguration"
                    :encode="false"
                >
                </CCMethodApiConfiguration>
                <!-- Match response body -->
                <CCTableAddItems
                    :items.sync="valueComponent.matchResponseBody"
                    :fields="[
                        {
                            key: 'condition',
                            label: 'condition',
                        },
                        {
                            key: 'value',
                            label: 'value',
                        },
                    ]"
                >
                    <template #condition="{ item }">
                        <CSelect
                            :value.sync="item.condition"
                            :options="[
                                {
                                    value: 'contains',
                                    label: 'Contains',
                                },
                                {
                                    value: 'not_contains',
                                    label: 'Not contains',
                                },
                            ]"
                            :placeholder="$t('Select a condition')"
                            size="sm"
                        />
                    </template>
                    <template #value="{ index, item }">
                        <CInput
                            :value.sync="item.value"
                            :placeholder="$t('Enter the value')"
                            :invalidFeedback="$t('Value is required')"
                            class="mb-0"
                            size="sm"
                        />
                    </template>
                </CCTableAddItems>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
import TableFixedFields from "~/components/TableFixedFields.vue";
import CCTableMappingFields from "~/components/CCTableMappingFields.vue";
import CCTableAddItems from "~/components/CCTableAddItems";
import CCMethodApiConfiguration from "~/components/CCMethodApiConfiguration.vue";

import tableMixin from "~/mixins/table.js";
import baseMixin from "~/mixins/base.js";

import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";

export default {
    name: "CCCappingByClientPreValidation",
    mixins: [baseMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    consts: {},
    options: {},
    components: {
        CCTableAddItems,
        CCMethodApiConfiguration,
        TableFixedFields,
        CCTableMappingFields,
    },
    data() {
        return {
            methodApiConfiguration: {
                url: null,
                method: "get",
                bodyFormat: "none",
                headers: [],
                queryParameters: [],
                formData: [],
                raw: null
            },
            valueComponent: {
                mappingFields: [],
                fixedFields: [],
                url: null,
                method: "get",
                bodyFormat: "none",
                headers: [],
                queryParameters: [],
                formData: [],
                raw: null,
                matchResponseBody: [],
            },
        };
    },
    props: {
        value: {
            required: true,
        },
        encode: {
            default: false,
        },
    },
    watch: {
        value(newValue) {
            if (this.value && this.encode) {
                const valueParsed = JSON.parse(this.value);
                this.handleComponentValue(valueParsed);
                this.handleMethodApiConfigurationValue(this.valueComponent);
            }
        },

        valueComponent: {
            handler(newValue) {
                this.$emit("update:value", this.getValue());
                this.$emit("change", this.getValue());
            },
            deep: true,
        },
        methodApiConfiguration: {
            handler(newValue) {
                this.valueComponent.url = newValue.url;
                this.valueComponent.method = newValue.method;
                this.valueComponent.bodyFormat = newValue.bodyFormat;
                this.valueComponent.headers = newValue.headers;
                this.valueComponent.formData = newValue.formData;
                this.valueComponent.raw = newValue.raw;
                this.valueComponent.queryParameters = newValue.queryParameters;
            },
            deep: true,
        },
    },
    methods: {
        getValue() {
            if (this.encode) {
                return JSON.stringify(this.valueComponent);
            }
            return this.valueComponent;
        },
        handleComponentValue(value) {
            for (const key in this.valueComponent) {
                if (Object.hasOwnProperty.call(value, key)) {
                    this.valueComponent[key] = value[key];
                }
            }
        },
        handleMethodApiConfigurationValue(value) {
            for (const key in this.methodApiConfiguration) {
                if (Object.hasOwnProperty.call(value, key)) {
                    this.methodApiConfiguration[key] = value[key];
                }
            }
        },
    },
    async mounted() {
        if (this.value && this.encode) {
            const valueParsed = JSON.parse(this.value);
            this.handleComponentValue(valueParsed);
            this.handleMethodApiConfigurationValue(this.valueComponent);
        }
    },
};
</script>

<style>
.range__not_defined {
    accent-color: gray;
}
</style>
